export const getFilterId = (domain: number, suffix: string) => `filter_${domain}_${suffix}`;
